var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"group":"notifications","position":'top right'},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('div',{staticClass:"notification",class:[props.item.type]},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(props.item.text))])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }